import { useCallback, useEffect, useState } from "react";
import {
  fetchDeveloperToken,
  updateDeveloperToken,
} from "../../api/application/developer-api-token";
import { showToast } from "../shared/global-tools/toast-system";

export default function useGetDeveloperToken(referenceId: number | undefined) {
  const [developerToken, setDeveloperToken] = useState<string>();
  const [loading, setLoading] = useState<boolean>(false);

  const fetchToken = useCallback(async () => {
    if (referenceId === undefined) return;
    setLoading(true);
    try {
      const token = await fetchDeveloperToken(referenceId);
      setDeveloperToken(token);
    } catch (error) {
      console.error("Error fetching developer token:", error);
    } finally {
      setLoading(false);
    }
  }, [referenceId]);

  const regenerateToken = useCallback(async () => {
    if (referenceId === undefined) return;
    setLoading(true);
    try {
      const newToken = await updateDeveloperToken(referenceId);
      setDeveloperToken(newToken);
      showToast("Clé API régénérée avec succès", { severity: "success" });
    } catch (error) {
      console.error("Error updating developer token:", error);
      showToast("Erreur lors de la régénération de la clé API", { severity: "error" });
    } finally {
      setLoading(false);
    }
  }, [referenceId]);

  useEffect(() => {
    fetchToken().catch(console.error);
  }, [fetchToken]);

  return { developerToken, loadingDeveloperToken: loading, regenerateToken };
}
